<template>
  <div class="canvas-container">
    <canvas v-if="ShowAnimation" id="scene" :width="Width"></canvas>
    <h3 class="main-header" v-else>{{Title}}</h3>
  </div>
</template>

<script>
export default {
  props: {
    Title: String,
    Size: Number,
    ForceMobile: Boolean,
  },
  mounted() {
    var isChrome =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    this.ShowAnimation = isChrome && (!this.$isMobile() || this.ForceMobile);
    if (this.ShowAnimation) this.initialize();
  },
  data() {
    return {
      ParticleRadius: this.$isMobile() ? 2 : 2,
      ParticlesColor: "#adc9ce",
      ParticlesRadiusSpread: 3,
      Height: 500,
      Width: this.$isMobile() ? 500 : 500,
      ShowAnimation: true,
    };
  },
  methods: {
    initialize() {
      let self = this;
      var canvas = document.querySelector("#scene"),
        ctx = canvas.getContext("2d"),
        particles = [],
        amount = 0,
        mouse = { x: 0, y: 0 },
        radius = 1;

      // holding canvas reference
      this.canvas_ = canvas;

      var ww = this.Width;
      var wh = this.Height;

      function Particle(x, y) {
        this.x = Math.random() * ww;
        this.y = Math.random() * wh;
        this.dest = {
          x: x,
          y: y,
        };
        this.r = self.ParticleRadius;
        this.vx = (Math.random() - 0.5) * 20;
        this.vy = (Math.random() - 0.5) * 20;
        this.accX = 0;
        this.accY = 0;
        this.friction = Math.random() * 0.05 + 0.94;

        this.color = self.ParticlesColor;
      }

      Particle.prototype.render = function () {
        this.accX = (this.dest.x - this.x) / 1000;
        this.accY = (this.dest.y - this.y) / 1000;
        this.vx += this.accX;
        this.vy += this.accY;
        this.vx *= this.friction;
        this.vy *= this.friction;

        this.x += this.vx;
        this.y += this.vy;

        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.r, Math.PI * 2, false);
        ctx.fill();

        var a = this.x - mouse.x;
        var b = this.y - mouse.y;

        var distance = Math.sqrt(a * a + b * b);
        if (distance < radius * 70) {
          this.accX = (this.x - mouse.x) / 100;
          this.accY = (this.y - mouse.y) / 100;
          this.vx += this.accX;
          this.vy += this.accY;
        }
      };

      function onMouseMove(e) {
        var canvasStyle =
          canvas.currentStyle || window.getComputedStyle(canvas);

        var containerStyle =
          canvas.parentElement.currentStyle ||
          window.getComputedStyle(canvas.parentElement);

        let marginLeft = Number.parseInt(
          canvasStyle.marginLeft.replace("px", "")
        );

        let positionTop = Number.parseInt(containerStyle.top.replace("px", ""));

        mouse.x = e.clientX - marginLeft;
        // changing the top property of the canvas container to align it
        // the added top pixels should be subtracted here
        mouse.y = e.clientY - positionTop;
      }

      function mouseout() {
        mouse.x = -9999;
        mouse.y = -9999;
      }

      function onTouchMove(e) {
        if (e.touches.length > 0) {
          mouse.x = e.touches[0].clientX;
          mouse.y = e.touches[0].clientY;
        }
      }

      function onTouchEnd() {
        mouse.x = -9999;
        mouse.y = -9999;
      }

      function initScene() {
        ww = canvas.width = self.Width;
        wh = canvas.height = self.Height;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.font = "bold " + ww / self.Size + "px arial";
        ctx.textAlign = "center";
        ctx.fillText(self.Title, ww / 2, wh / 2);

        var data = ctx.getImageData(0, 0, ww, wh).data;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.globalCompositeOperation = "screen";

        particles = [];
        for (var i = 0; i < ww; i += Math.round(ww / 150)) {
          for (var j = 0; j < wh; j += Math.round(ww / 150)) {
            if (data[(i + j * ww) * 4 + 3] > 150) {
              particles.push(new Particle(i, j));
            }
          }
        }
        amount = particles.length;
      }

      function onMouseClick() {
        self.ParticlesRadiusSpreadradius++;
        if (self.ParticlesRadiusSpreadradius === 3) {
          self.ParticlesRadiusSpreadradius = 0;
        }
      }

      function render() {
        requestAnimationFrame(render);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < amount; i++) {
          particles[i].render();
        }
      }

      canvas.addEventListener("resize", initScene);
      canvas.addEventListener("mousemove", onMouseMove);
      canvas.addEventListener("touchmove", onTouchMove);
      canvas.addEventListener("click", onMouseClick);
      canvas.addEventListener("touchend", onTouchEnd);
      canvas.addEventListener("mouseout", mouseout);
      initScene();
      requestAnimationFrame(render);
    },
  },
};
</script>

<style>
.canvas-container {
  position: absolute;
  left: 0px;
  top: -100px;
  width: 100%;
  height: 0;
  z-index: 9999;
}

#scene {
  margin: 0 auto;
  height: 500px;
  max-width: 100%;
}

h3.main-header {
  text-align: center;
  position: absolute;
  top: 189px;
  width: 100%;
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .canvas-container {
    top: -100px;
  }

  h3.main-header {
    top: 210px;
    color: #adc9ce;
  }
}
</style>